module.exports = __webpack_public_path__ + "media/components/assets/hero_images_03-4cede349bbf0eca9e571749c3d48e873.png";